import {Route, Routes} from 'react-router-dom';
import ReferralProgram from './referralProgram';
import {UpdateReferralProgram} from './updateReferral';

const AdminReferralProgram = () => {
  return (
    <Routes>
      <Route path="/" element={<ReferralProgram />} />
      <Route path="/update-referral/:id" element={<UpdateReferralProgram />} />
    </Routes>
  );
};

export {AdminReferralProgram};
